import { makeObservable, observable, computed, action } from 'mobx';
import bucketList from './BucketList';
import { erpApiurl } from '../stores/APIEndpoints';

const PENDING = 'pending';
const DONE = 'done';
const ERROR = 'error';

const EMPTY_MESSAGE = { status: "", help: "" };
const ERROR_MESSAGE = { status: "error", help: "Unable to fetch the Payables. The Service is unavailable. Please try after sometime." };

export default class PayableStore {

    state = PENDING;
    message = EMPTY_MESSAGE;
    payables = [];
    filteredPayables = [];
    errorReffererIds = new Set();
    bucket;
    branchList = [
        {
            value: 0, label: 'All Branch'
        }
    ];
    bucketList = [
        {
            value: 0, label: 'All',
            
        }
    ];
    branchId = 0;
    rowCount = 0;
    totalPayableSum = 0;

    constructor(props) {
        this.apiProxy = props.apiProxy;
        this.collectionType = props.collectionType;

        this.bucket = new bucketList();

        this.bucket.getDateData(this.bucketList);

        makeObservable(this, {
            state: observable,
            message: observable,
            payables: observable,
            rowCount: observable,
            filteredPayables: observable,
            branchId: observable,
            errorReffererIds: observable,

            isLoading: computed,
            isError: computed,
            isDone: computed,

            fetchPayableSummary: action,
            removeErrors: action,
            GetallBranchName: action,
        });
    }


    get isLoading() {
        return this.state === PENDING;
    }

    get isError() {
        return this.state === ERROR;
    }

    get isDone() {
        return this.state === DONE;
    }

   
    GetallBranchName = async() => {
  
        const payload = {
            BranchId:0,
        }

        const reportUrl = `${erpApiurl}api/carbon/LTBranchDetails`;
        const response = await this.apiProxy.asyncPost(reportUrl,payload);
        const branches = await response.json();


        branches.map((branch) => {
            const branchVal = {
                value: branch.BranchId,
                label: branch.BranchName
            }   

            this.branchList.push(branchVal)
            }
        );

    }   

    filterBranch = (value) => {

        this.branchId = value;
        this.fetchPayableSummary();

    }

    filterBucket = (value1,value2) => {

        let payData = this.payables;

        if(value1 !== 'All') {
            payData = this.payables.filter((ele) => (ele.bucket >= value1 && ele.bucket <= value2));
        }

        this.totalPayableSum =  payData.map(item => item.Payable).reduce((a, b) => a + b, 0);

        this.rowCount = payData.length;

        this.filteredPayables = payData;
    }
 
   
    /**
     * Send the request to the endpoint using the FetchAPI
     * 
     */
    fetchPayableSummary = async () => {

        const url = `${erpApiurl}api/Carbon/GetIcSummary?collectionType=${this.collectionType}&branchId=${this.branchId}`;
        this.state = PENDING;
        this.message = EMPTY_MESSAGE;

        try {
            const response = await this.apiProxy.getAsync(url);
            const buckets = await response.json();

            if (buckets.Message) {
                this.message = ERROR_MESSAGE;
                this.state = DONE;
                return;
            }

            const data = this.removeErrors(buckets,this.errorReffererIds);
            this.payables = data;
            this.filteredPayables = data;
            this.rowCount = data.length;
            this.totalPayableSum = 0;
            data.map((payable) =>
                this.totalPayableSum = this.totalPayableSum + payable.Payable      
            );
            this.state = DONE;
        }
        catch (e) {
            this.state = ERROR;
            this.message = ERROR_MESSAGE
            console.log(e);
        }
    }

    removeErrors = (buckets,errorReffererIds) => {
        const data = [];
        for(let i=0;i<buckets.length;i++) {
            const payable = buckets[i];
            if(!errorReffererIds.has(payable.ReferrerId)) {
                data.push(payable);
            }
        }
        return data;
    }
}
